<template>
	<div>
		<p class="ui-title">Login</p>
		<ui-form
			:is-processing="isProcessing"
			:valid.sync="formValid"
			@submit="login"
		>
			<ui-input
				v-model="email"
				fixed-label
				label="E-mail"
				required
				type="email"
			/>
			<ui-input
				v-model="password"
				fixed-label
				label="Password"
				required
				type="password"
			/>
			<div class="ui-layout ui-alignment-center-space-between" style="flex-wrap:nowrap">
				<router-link :to="{name: 'ForgotPassword'}">Forgot password?</router-link>
				<ui-button
					:disabled="isProcessing"
					primary
					raised
					text="Log in"
					type="submit"
				/>
			</div>
		</ui-form>
		<router-link
			v-if="!hideRegistration"
			:to="{name: 'Register'}"
		>
			Register
		</router-link>
	</div>
</template>

<script>
import UiButton from "lib/components/ui/Button";
import UiForm from "lib/components/ui/Form";
import UiInput from "lib/components/ui/Input";
import auth from "lib/modules/Auth";
import alert from "lib/modules/Alert";

export default {
	name: "Login",
	components: {
		UiButton,
		UiForm,
		UiInput
	},
	props: {
		hideRegistration: {
			type: Boolean,
			required: true
		},
		target: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			formValid: false,
			isProcessing: false,
			email: "",
			password: ""
		};
	},
	mounted() {
		this.$el.querySelector("input").focus();
	},
	methods: {
		login() {
			this.isProcessing = true;

			auth.login(this.email, this.password).then(() => {
				try {
					const target = new URL(location.origin + this.target);

					if (target.origin === location.origin)
						location.assign(target.href);
					else
						location.assign("/");
				}
				catch (e) {
					location.assign("/");
				}
			})
			.catch((error) => {
				alert.error("Authentication error", error.response);
				this.isProcessing = false;
			});
		}
	}
};
</script>
